import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=be892500&scoped=true&"
import script from "./StarRating.vue?vue&type=script&lang=js&"
export * from "./StarRating.vue?vue&type=script&lang=js&"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=be892500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be892500",
  null
  
)

export default component.exports